import { FraudAlertDto } from './dtos/FraudAlertDto';
import { FraudAlert } from '../../domain/entities';

export const toDomain = (el: FraudAlertDto): FraudAlert => {
    return {
        noteDescription: el.description,
    };
};
